import cloneDeep from 'lodash/cloneDeep';
import { ECustomFieldType } from '../../custom-fields/custom-field-types-enums';
import { GET_CUSTOM_FIELDS } from '../../custom-fields/custom-fields.store';
import { TSavedView } from '../models/saved-view.model';

// TODO Remove fixViewCustomFields function when PS-1309 is done
export function fixViewCustomFields(view: TSavedView): TSavedView {
  const newView = cloneDeep(view);

  updateCustomFieldNames(newView);

  return newView;
}

function updateCustomFieldNames(newView: TSavedView): void {
  if (!newView.columns) {
    return;
  }

  const allCustomFields = GET_CUSTOM_FIELDS();

  newView.columns = newView.columns.reduce((array, column) => {
    if (!column.customFieldIds?.length) {
      return [...array, column];
    }

    const knownField = column.customFieldIds
      .map((id) => allCustomFields[id.toString()])
      .find((cf) => cf);

    if (!knownField) {
      return array;
    }

    const matchingIds = Object.keys(allCustomFields).filter((id) => {
      const candidate = allCustomFields[id];

      if (candidate.label !== knownField.label) {
        return false;
      }

      if (knownField.type === ECustomFieldType.COST) {
        return candidate.currencyCode === knownField.currencyCode;
      }

      return true;
    });

    const mergedIds = [...new Set([...column.customFieldIds.map(String), ...matchingIds])];

    const isSingleCustomFieldColumn = column.customFieldIds.length === 1;
    const name = isSingleCustomFieldColumn ? knownField.label : column.name;

    return [...array, { ...column, name, customFieldIds: mergedIds }];
  }, []);
}
